import { render, staticRenderFns } from "./youLove.vue?vue&type=template&id=7c66fa00&scoped=true"
import script from "./youLove.vue?vue&type=script&lang=js"
export * from "./youLove.vue?vue&type=script&lang=js"
import style0 from "./youLove.vue?vue&type=style&index=0&id=7c66fa00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66fa00",
  null
  
)

export default component.exports